import Api from './Api'
import csrf from './csrf'
export default {

	async register(data){
		await csrf.getCookie();
		return Api.post('/register',data)
	},
	async login(data){
		await csrf.getCookie();
		return Api.post('/login',data)
	},

	async logout(data){
		await csrf.getCookie();

		return Api.post('/user/logout')
	},
	
	async self(){
		await csrf.getCookie();

		return Api.get('/user')
	},
	
	async stripeSession(){
		await csrf.getCookie();

		return Api.post('/user/stripe')
	},


	async verifyEmail(params){
		await csrf.getCookie();
		const url = '/email/verify?' + Object.keys(params).map(key => key + '=' + params[key]).join('&');
		
		return Api.get(url);
	},


	async resetPassword(data){
		await csrf.getCookie();
		return Api.post('/password/reset', data);
	},

	async verifyResetPasswordLink(params){
		await csrf.getCookie();
		const url = '/password/email?' + Object.keys(params).map(key => key + '=' + params[key]).join('&');
		
		return Api.get(url);
	},
	async updatePassword(data){
		await csrf.getCookie();
		return Api.post('/password/email', data);
	},

	

}